import { render } from "./printReceipt.vue?vue&type=template&id=28246f65&scoped=true"
import script from "./printReceipt.vue?vue&type=script&lang=js"
export * from "./printReceipt.vue?vue&type=script&lang=js"

import "./printReceipt.vue?vue&type=style&index=0&id=28246f65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28246f65"]])

export default __exports__